import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const HomePageComponent = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/agent');
    }, []);

    return <h1>Hola</h1>;
};
